import { Grid, IconButton, Typography } from '@mui/material';
import { AddOutlined, Delete } from '@mui/icons-material';
import { Fragment, memo, ReactElement, useMemo, useState } from 'react';
import { BaseTableRows, HeadCell } from 'shell/components/shared/table/types';
import TerritoryAutoComplete from './autocomplete';
import TableTerritory from './table';

export interface TerritoryVM extends BaseTableRows {
  code: string;
  description: string;
  remove?: ReactElement;
}

export const headCells: HeadCell<TerritoryVM, keyof TerritoryVM>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Territorio',
  },
  {
    id: 'remove',
    label: 'Elimina',
  },
];

interface FormTerritoryProps {
  selectedValues: Array<TerritoryVM>;
  handleAdd: (value: TerritoryVM | null) => void;
  handleRemove: (value: TerritoryVM | null) => void;
  disabled?: boolean;
  label?: string;
  error?: boolean;
}

const TerritoryAutoCompleteTableComponent = ({
  selectedValues,
  handleAdd,
  handleRemove,
  disabled,
  error,
}: FormTerritoryProps): React.ReactElement => {
  const [selectedItem, setSelectedItem] = useState<TerritoryVM | null>(null);
  const [page, setPage] = useState<number>(0);

  const territories: Array<TerritoryVM> = useMemo(() => {
    return selectedValues.map((territory) => {
      return {
        ...territory,
        remove: (
          <IconButton
            disabled={disabled}
            aria-label="Elimina elemento"
            color="cdmBrand"
            onClick={() => {
              handleRemove(territory);
            }}
          >
            <Delete />
          </IconButton>
        ),
      };
    });
  }, [selectedValues]);

  return (
    <Fragment>
      <Grid item xs={12} md={8}>
        <div className="pmi-d-flex pmi-align-items-center">
          <TerritoryAutoComplete
            selectedValue={selectedItem}
            handleChange={setSelectedItem}
            error={error}
            disabled={disabled}
          />
          <IconButton
            disabled={disabled}
            onClick={() => {
              if (selectedItem) {
                handleAdd(selectedItem);
              }
            }}
          >
            <AddOutlined />
          </IconButton>
        </div>
      </Grid>
      {territories.length > 0 ? (
        <Grid item xs={12}>
          <div className="pmi-pt-3">
            <Typography color="secondary" marginBottom="0.5rem" fontWeight="bold">
              Territori associati
            </Typography>
            <TableTerritory
              head={headCells}
              body={territories || []}
              page={page}
              onChangePage={(newPage) => {
                setPage(newPage || 0);
              }}
              count={territories?.length || 0}
              ariaLabel="Tabella Territori"
            />
          </div>
        </Grid>
      ) : undefined}
    </Fragment>
  );
};

TerritoryAutoCompleteTableComponent.displayName = 'Territory Auto Complete with table component';

const TerritoryAutoCompleteTable = memo(
  TerritoryAutoCompleteTableComponent
) as typeof TerritoryAutoCompleteTableComponent;

export default TerritoryAutoCompleteTable;
